import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import User from '_class/User';
import DateTime from '_class/DateTime';
import { getUserMeetings } from 'actions/meetings';
import { Spinner } from 'UI';
import { Block, translate } from '@haldor/ui';

var UserMeetings = /*#__PURE__*/function (_Component) {
  _inherits(UserMeetings, _Component);

  var _super = _createSuper(UserMeetings);

  function UserMeetings(props) {
    var _this;

    _classCallCheck(this, UserMeetings);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, start, end;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, start = _this$props.start, end = _this$props.end;
              _context.next = 3;
              return _this.props.getUserMeetings(_this.props.user, start, end);

            case 3:
              _this.setState({
                loading: false
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(nextProps) {
        var start, end;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                start = nextProps.start, end = nextProps.end;

                if (!(nextProps.start == _this.props.start && nextProps.end == _this.props.end)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", false);

              case 3:
                if (!(_this.props.start != start || _this.props.end != end)) {
                  _context2.next = 8;
                  break;
                }

                _this.setState({
                  loading: true
                });

                _context2.next = 7;
                return _this.props.getUserMeetings(_this.props.user, start, end);

              case 7:
                _this.setState({
                  loading: false
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "renderMeetingInfo", function (meeting) {
      if (meeting == null || meeting.instances == null || meeting.instances.length == 0) {
        return null;
      }

      var instance = meeting.instances[0];

      if (instance == null) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", null, instance.date != null ? /*#__PURE__*/React.createElement("span", {
        className: "color--meta size-12"
      }, new DateTime(instance.date).getLongDateWithTime()) : null, instance.status == "COMPLETED" ? /*#__PURE__*/React.createElement("span", {
        className: "new-badge",
        style: {
          marginLeft: '.5rem'
        }
      }, _this.props.translate('complete-meeting')) : null, /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    });

    _this.state = {
      loading: true
    };
    return _this;
  }

  _createClass(UserMeetings, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var user = new User(this.props.currentUser);

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", {
          className: "meeting"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      if (this.props.meetings == null) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "meeting"
      }, this.props.meetings.map(function (meeting) {
        var _meeting$instances$;

        if (meeting.status == "DRAFT") {
          return null;
        }

        return /*#__PURE__*/React.createElement(Link, {
          to: "/meeting/".concat(meeting.id, "/instance/").concat((_meeting$instances$ = meeting.instances[0]) === null || _meeting$instances$ === void 0 ? void 0 : _meeting$instances$.id),
          key: meeting.id
        }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
          className: "title"
        }, meeting.title), _this2.renderMeetingInfo(meeting)));
      }));
    }
  }]);

  return UserMeetings;
}(Component);

function mapStateToProps(state) {
  return {
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations),
    meetings: state.Meetings.user
  };
}

;
export default connect(mapStateToProps, {
  getUserMeetings: getUserMeetings
})(UserMeetings);